import React, { useEffect, createElement } from 'react';
import { UrgencyBar } from './components/UrgencyBar';
import { Hero } from './components/Hero';
import { Reviews } from './components/Reviews';
import { TargetAudience } from './components/TargetAudience';
import { Problem } from './components/Problem';
import { Volumes } from './components/Volumes';
import { BaseBonuses } from './components/BaseBonuses';
import { ProBonuses } from './components/ProBonuses';
import { Comparison } from './components/Comparison';
import { Pricing } from './components/Pricing';
import { Guarantee } from './components/Guarantee';
import { FAQ } from './components/FAQ';
import { Footer } from './components/Footer';
const META_PIXEL_ID = '931401796468747';
export function App() {
  useEffect(() => {
    // Meta Pixel base code
    const w = window as any;
    if (!w.fbq) {
      const n: any = w.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!w._fbq) w._fbq = n;
      n.push = n;
      n.loaded = true;
      n.version = '2.0';
      n.queue = [];
      const t = document.createElement('script');
      t.async = true;
      t.src = 'https://connect.facebook.net/en_US/fbevents.js';
      // Safely inject the script: append to <head> (or fall back to
      // documentElement / insert before an existing script if present).
      const firstScript = document.getElementsByTagName('script')[0];
      if (firstScript && firstScript.parentNode) {
        firstScript.parentNode.insertBefore(t, firstScript);
      } else {
        ;
        (document.head || document.documentElement).appendChild(t);
      }
    }
    w.fbq('init', META_PIXEL_ID);
    w.fbq('track', 'PageView');
  }, []);
  return <div className="min-h-screen bg-cream font-sans text-dark selection:bg-pink-pastel/50" data-id="element-0">
      <UrgencyBar data-id="element-1" />
      <main data-id="element-2">
        <Hero data-id="element-3" />
        <Reviews data-id="element-4" />
        <TargetAudience data-id="element-5" />
        <Problem data-id="element-6" />
        <Volumes data-id="element-7" />
        <BaseBonuses data-id="element-8" />
        <ProBonuses data-id="element-9" />
        <Comparison data-id="element-10" />
        <Pricing data-id="element-11" />
        <Guarantee data-id="element-12" />
        <FAQ data-id="element-13" />
      </main>
      <Footer data-id="element-14" />
    </div>;
}